import BaseNotification from '../BaseNotification'

export default class PassengerConfirmed extends BaseNotification {
  get iconClass(): string {
    return 'sc-icon-person-hollow'
  }
}
